module.exports = __webpack_public_path__ + "static/media/combat(13).d7ff4502.PNG";